import { render } from "./PortfolioNavigationSocialLinks.vue?vue&type=template&id=0e38d0d7&scoped=true"
import script from "./PortfolioNavigationSocialLinks.vue?vue&type=script&lang=js"
export * from "./PortfolioNavigationSocialLinks.vue?vue&type=script&lang=js"

import "./PortfolioNavigationSocialLinks.vue?vue&type=style&index=0&id=0e38d0d7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e38d0d7"],['__file',"src/scripts/view/portfolio/sections/common/navigation/PortfolioNavigationSocialLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e38d0d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e38d0d7', __exports__)) {
    api.reload('0e38d0d7', __exports__)
  }
  
  module.hot.accept("./PortfolioNavigationSocialLinks.vue?vue&type=template&id=0e38d0d7&scoped=true", () => {
    api.rerender('0e38d0d7', render)
  })

}


export default __exports__